export default __webpack_public_path__ + "static/media/sideLogo.1ca3e106.png";